export default "__VITE_ASSET__KUYAqXrp__"